import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {types, endpoints} from 'main/tools';
import {FormattedMessage} from 'react-intl';
import {EmployeeNameWithAvatar, AvatarList, Layout} from 'shared/components';
import {InteractiveTable, DropdownFilter} from 'main/components';
import {PerformanceReviewReviewee} from 'main/stores/performance_reviews';
import Subnav from '../../Subnav';
import CycleName from './CycleName';

const COLUMNS = [
  {
    header: 'performance_reviews.view.Reviewee',
    render: (model => <EmployeeNameWithAvatar to={`${model.writeReviewsPath}/reviewees`} employee={model.employee} size='sm'/>),
    width: 2
  },
  {
    header: 'performance_reviews.view.Cycle',
    render: model => <CycleName cycle={model.cycle}/>,
    width: 3
  },
  {
    header: 'performance_reviews.view.Reviewers',
    render: (model => <AvatarList limit={3} moreModalEnabled employees={model.reviewers}/>),
    width: 2
  },
  {
    header: 'performance_reviews.view.Due Date',
    render: (model => model.dueDateView),
    width: 1.5
  },
  {
    header: 'performance_reviews.view.Launch Date',
    render: (model => model.launchDateView),
    width: 1.5
  },
  {
    header: 'performance_reviews.view.Status',
    render: (model => <FormattedMessage
      id='performance_reviews.view.REVIEWS_RECEIVED'
      values={{received: model.completedReviews, total: model.totalReviews}}/>),
    width: 2,
  }
];

const LOCALIZATION = {
  emptyState: 'performance_reviews.directory.No performance reviews to display',
};

function statusFilters() {
  const filters = [
    {
      id: 'live',
      display: t('performance_reviews.directory.In Progress')
    },
    {
      id: 'scheduled',
      display: t('performance_reviews.directory.Scheduled')
    },
    {
      id: 'closed',
      display: t('performance_reviews.directory.Closed')
    }
  ];

  return filters;
}

const RevieweesDirectory = observer(({scope}) => {
  return (
    <div>
      <Subnav scope={scope}/>
      <Layout>
        <InteractiveTable
          title={t('performance_reviews.Performance reviews')}
          columns={COLUMNS}
          localization={LOCALIZATION}
          showLinks={false}
          saveStateToUrl
          searchable
          proxy={{
            type: 'async',
            modelType: types.PERFORMANCE_REVIEWS.REVIEWEE,
            model: PerformanceReviewReviewee,
            endpoint: endpoints.PERFORMANCE_REVIEWS.REVIEWEES.ALL
          }}
        >
          <DropdownFilter options={statusFilters()} attr='status'/>
        </InteractiveTable>
      </Layout>
    </div>
  );
});

export default RevieweesDirectory;
